import React from "react";
import { imagesCode } from "../../template_codes/nextgadget/home_page_codes";

const Test = () => {
  return (
    <div className="bg-gray-700 flex flex-col-reverse lg:flex-row justify-center lg:justify-evenly items-center p-10 rounded-2xl shadow-lg mb-10 gap-5">
      <img
        src={imagesCode.banner5.image}
        alt=""
        className="w-52 lg:w-80 rounded-2xl"
      />
      <div className="">
        <h1 className="text-4xl md:text-7xl text-gray-100 font-extrabold">
          NEXT POS
        </h1>
        <p className=" text-gray-400 mt-3">1,560,200 K</p>
        <a href="https://nextgadgetshop.com/product/cld1gmocf1189501s6aryuj6tx">
          <button className="btn bg-white text-gray-700 outline-none border-none px-10 rounded shadow-lg hover:bg-white hover:scale-105 transition duration-200">
            Shop Now
          </button>
        </a>
      </div>
    </div>
  );
};

export default Test;
